import { ProfitabilityEstimateDTOFxRates } from 'api';
import { useTranslation } from 'i18n';
import { Box, Typography } from 'ui';

export const CurrencyRates = ({ fxRates }: { fxRates: ProfitabilityEstimateDTOFxRates }) => {
  const { t } = useTranslation('orders');

  return (
    fxRates && (
      <>
        <Typography
          variant="h5"
          sx={{
            paddingY: 2,
          }}
        >
          {t('profitabilityCalculator.currencyRates.title')}
        </Typography>
        {Object.entries(fxRates).map(([base, quoteRates]) => (
          <div key={base}>
            {Object.entries(quoteRates).map(([quote, rate]) => (
              <Box component="p" key={`${base}-${quote}`}>
                {base}/{quote} = {rate}
              </Box>
            ))}
          </div>
        ))}
      </>
    )
  );
};
